import { styled } from 'styled-system/jsx'

const IconShell = styled('span', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'book.primarySoft',
    color: 'book.primary',
    borderRadius: 'md',
    flexShrink: 0,
  },
  variants: {
    size: {
      small: { width: '32px', height: '32px' },
      medium: { width: '44px', height: '44px' },
      large: { width: '56px', height: '56px' },
    },
  },
  defaultVariants: { size: 'medium' },
})

export { IconShell }
